import { render, staticRenderFns } from "./Article1Content.vue?vue&type=template&id=86e86de4&scoped=true"
var script = {}
import style0 from "./Article1Content.vue?vue&type=style&index=0&id=86e86de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e86de4",
  null
  
)

export default component.exports